{
  "it": {
    "ai": {
      "assistant": {
        "all_projects": "Tutti i progetti",
        "cap": {
          "action": "Avvia una nuova conversazione",
          "message": "Ha raggiunto il limite di conversazioni."
        },
        "empty_state": {
          "subtitle": "Mi chieda qualsiasi cosa sui Suoi clienti",
          "title": "Come posso aiutarLa?"
        },
        "errors": {
          "budget_reached": "Il budget AI mensile per questo spazio di lavoro è stato raggiunto. Contatti un amministratore per aumentare il limite.",
          "generic": "Qualcosa è andato storto. Riprovi."
        },
        "history": {
          "empty": "Nessuna conversazione precedente",
          "title": "Conversazioni precedenti"
        },
        "input": {
          "disclaimer": "I risultati potrebbero non essere accurati. Verifichi sempre le informazioni importanti.",
          "hint": "Invio per inviare · Maiusc+Invio per andare a capo",
          "placeholder": "Chieda dei Suoi clienti…"
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Come configuro le notifiche?",
          "help_project_settings": "Dove trovo le impostazioni del progetto?",
          "open_decisions": "Quali decisioni sono ancora aperte?",
          "unassigned_units": "Quali unità non hanno ancora un cliente?"
        },
        "support_cta": {
          "action": "Contatta il supporto",
          "prompt": "Non è la risposta che cercava?"
        }
      },
      "settings": {
        "budget": {
          "description": "Limite di spesa mensile per l'utilizzo dell'AI (fase di test). Ricalcolato in base all'utilizzo dei token in tutte le conversazioni di questo mese.",
          "free_label": "Budget gratuito",
          "override_help": "Lasci vuoto per utilizzare l'importo del pacchetto ({amount}).",
          "override_label": "Budget gratuito personalizzato",
          "paid_label": "Budget a pagamento",
          "save": "Salva",
          "title": "Budget mensile",
          "total_label": "Budget totale",
          "usage_label": "Utilizzato questo mese",
          "use_package_amount": "Usa l'importo del pacchetto"
        },
        "description": "Configurazione delle funzionalità AI nel Suo spazio di lavoro.",
        "title": "Impostazioni AI",
        "usage": {
          "description": "Quanto del credito AI di questo mese è stato utilizzato. Al 100% le funzioni AI si fermano fino al rinnovo del credito il mese prossimo.",
          "title": "Utilizzo dell'AI"
        }
      }
    }
  }
}
